// extracted by mini-css-extract-plugin
export default {"select":"Quotes_select__0lNyC","container":"Quotes_container__F1oWF"};